import React, { ReactChild, ReactFragment, ReactPortal } from "react";
interface ILabelProps {
  className?: string;
  children?:
    | ReactChild
    | ReactFragment
    | ReactPortal
    | boolean
    | null
    | undefined;
}
const Label = ({ className, children }: ILabelProps) => (
  <label className={className}>{children}</label>
);

export default Label;
